import { gql } from "@apollo/client";

export const GET_DELEGACIONES = gql`
query allDelegaciones(
  $where: t_DelegacionFilterInput
  $order: [t_DelegacionSortInput!]
  ){
    allDelegaciones(where: $where, order: $order) {     
        idDelegacion,
        cod_Delegacion,
        descripcion
    }
  }
`;